import 'babel-polyfill';

// SCSS entry file
import '../_scss/main.scss';

// Load all image files from a directory
//require.context( '../_img/', true, /.*/ );

import $ from 'jquery';

import 'magnific-popup';

import './components/root';
import './smoothscroll';
import './cookie-script-localstorage';

$('.js-download-files__trigger').magnificPopup({
	type: 'inline',
	midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});



// WEBPACK FOOTER //
// ./assets/_js/main.js